import { useEffect } from "react";
import DocumentTitle from "react-document-title";
import Sidebar1 from "../../Layout/Sidebar";
import Header from "../../Layout/Header";
import { ensureSubscriptionFlag, useSubscriptionFlag } from "./subscriptionFlagStore";
import { FREE_USER_TEXT, isFreeUser } from "./flagReasons";
import "../Subscription.css";

// ================================================================
// Free User gate (backend guide S8c "Free User Access").
//
// Where : wraps the AutoPay (/autopay-mandate) and Subscription Billing
//         (/subscription-billing) routes in routes/billingRoutes.js.
// What  : employees on the admin's Free User Access list come back from
//         subscription-flag with Reason = EXEMPT / IsExempt. They have no
//         AutoPay, no subscription fee and no invoice, so these screens
//         are hidden: the menu links are dropped (Sidebar / Header) and a
//         direct URL shows this notice instead of the screen. The wrapped
//         screen isn't even mounted, so its APIs aren't called.
// Flag  : ensureSubscriptionFlag — cached answer, no extra call normally.
//         Fail-open: no flag (still loading / check failed) → the screen
//         renders as usual.
// ================================================================
const FreeUserGate = ({ children }) => {
  const { flag } = useSubscriptionFlag();

  useEffect(() => {
    ensureSubscriptionFlag();
  }, []);

  if (!isFreeUser(flag)) return children;

  return (
    <DocumentTitle title="Free User | KSDPL">
      <>
        <Sidebar1 />
        <section className="home">
          <Header />
          <div className="fully-bodywrap">
            <div className="sub-banner sub-banner--info" style={{ margin: 16 }}>
              <i className="bx bx-gift" />
              <div>
                <strong>Free User Access</strong>
                <div style={{ marginTop: 4 }}>{FREE_USER_TEXT}</div>
              </div>
            </div>
          </div>
        </section>
      </>
    </DocumentTitle>
  );
};

export default FreeUserGate;
